/**
 * HUB-H — Onglets sections équipe.
 */
import React from 'react';
import { EQUIPE_SECTIONS } from '../../utils/equipe/equipeDisplay';

const SECTIONS = [
  { id: EQUIPE_SECTIONS.OVERVIEW, label: "Vue d'ensemble" },
  { id: EQUIPE_SECTIONS.AUDIT, label: 'Journal audit' },
  { id: EQUIPE_SECTIONS.ALERTES, label: 'Alertes' },
  { id: EQUIPE_SECTIONS.SECURITE, label: 'Sécurité' },
];

export default function ActiviteEquipeSectionTabs({ activeSection, onSectionChange, counts = {} }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid="activite-equipe-section-tabs">
      {SECTIONS.map((section) => {
        const isActive = activeSection === section.id;
        const count = counts[section.id];
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => onSectionChange(section.id)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold border ${
              isActive ? 'text-[var(--rm-white)]' : 'text-[var(--rm-gray-400)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`activite-equipe-section-${section.id}`}
          >
            {section.label}
            {count != null && count > 0 && (
              <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-xs rm-badge rm-badge--muted">{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
